import styled, { keyframes } from 'styled-components';

const RIBBON_COLOR = '#ff8732';

const slideIn = keyframes`
  from {
    transform: translateX(-15px)
  } to {
    opacity: 1;
    transform: translateX(0)
  }
`;

export const RibbonWrapper = styled.div`
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: calc(100% - 8px);
  z-index: ${Styles.zIndex.max};
`;

export const RibbonContent = styled.div`
  position: relative;
  opacity: 0;
  animation: ${slideIn} 0.4s 0.15s forwards;
  z-index: ${Styles.zIndex.normal};
`;

export const StyledRibbon = styled.div`
  background-color: ${RIBBON_COLOR};
  font-family: ${Styles.fontFamily.brand};
  font-size: 0.75rem;
  height: 1.5rem;
  position: relative;
  color: #ffffff;
  text-align: left;
  padding: 0.375rem 0.2rem 0.375rem 0.75rem;
  line-height: 1;
  z-index: ${Styles.zIndex.top};
  font-weight: ${Styles.fontWeight.normal};

  &::before,
  &::after {
    content: '';
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: -4px;
    height: 1.5rem;
    width: 1rem;
    background-color: ${RIBBON_COLOR};
    z-index: -1;
  }

  &::before {
    transform: rotate(-0deg) skewX(-35deg);
    border-top-right-radius: 20%;
  }

  &::after {
    transform: rotate(180deg) skewX(35deg);
    border-top-left-radius: 20%;
  }
`;
